module.exports = __webpack_public_path__ + "dist/media/logo-white.468e7a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white.png
// module id = 355
// module chunks = 0